// SmartDashboardRoute.js - Versão simplificada
import React, { useContext } from "react";
import UserContext from "../../../contexts/UserContext";
import Dashboard from "../../components/Dashboard/Dashboard";
import { Spinner, Card } from "react-bootstrap";
import { IconRoute } from "@tabler/icons-react";
import WelcomeScreen from "../../../screens/Welcome/WelcomeScreen";

const SmartDashboardRoute = () => {
  const { user, hasPermission, permissionsLoading, isInitializing } =
    useContext(UserContext);

  // Loading state
  if (isInitializing || permissionsLoading) {
    return (
      <div className="container mt-5">
        <Card className="border-0 shadow-sm">
          <Card.Body className="text-center p-5">
            <IconRoute size={64} className="text-primary mb-3" />
            <h5 className="text-primary mb-2">Carregando...</h5>
            <p className="text-muted mb-3">Verificando suas permissões</p>
            <Spinner animation="border" variant="primary" size="sm" />
          </Card.Body>
        </Card>
      </div>
    );
  }

  // Para usuários level=0 (sem privilégios), mostrar WelcomeScreen
  if (user?.superuser_level === 0 && user?.is_superuser === 0) {
    console.log(
      "🎯 SmartDashboardRoute: Usuário level=0 - Exibindo WelcomeScreen"
    );
    return <WelcomeScreen />;
  }

  // Para outros usuários, verificar permissão para Dashboard
  /* if (hasPermission("Dashboard", "read")) {
    console.log("✅ SmartDashboardRoute: Usuário tem acesso ao Dashboard");
    return <Dashboard />;
  } */

    if (user?.is_superuser === 1) {
      console.log("✅ SmartDashboardRoute: Usuário tem acesso ao Dashboard");
      return <Dashboard />;
    }

  // Se não tem acesso ao Dashboard, mostrar erro de permissão
  return (
    <div className="container mt-5">
      <Card className="border-warning">
        <Card.Body className="text-center p-5">
          <h4 className="text-warning mb-3">Acesso Negado</h4>
          <p className="text-muted mb-4">
            Você não tem permissão para acessar o Dashboard.
          </p>
          <p className="text-muted">
            Entre em contato com seu administrador para solicitar acesso.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SmartDashboardRoute;
